<div class="stick-top">
  <mat-toolbar><mat-icon>message</mat-icon> USSD Carriers</mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button mat-raised-button class="primary" routerLink="/ussdCarriers/0">
      <mat-icon>add</mat-icon>
      Create a new USSD Carrier
    </button>
  </div>
</div>

<div class="padded">
  <table class="basicTable">
    <thead>
    <tr>
      <th>
        <div class="vbox">
          Name
          <input [(ngModel)]="filter.name">
        </div>
      </th>
      <th>
        <div class="vbox">
          Public Access Key
          <input [(ngModel)]="filter.publicAccessKey">
        </div>
      </th>
      <th>
        <div class="vbox">
          Enabled
          <select [(ngModel)]="filter.enabled">
            <option value="">ALL</option>
            <option value="true">ENABLED</option>
            <option value="false">DISABLED</option>
          </select>
        </div>
      </th>
      <th>
        <div class="vbox">
          Type
          <micro-ussdCarrierType-select [(ussdCarrierType)]="filter.ussdCarrierType" ></micro-ussdCarrierType-select>
        </div>
      </th>
      <th>
        <div class="vbox">
          Host
          <input [(ngModel)]="filter.host">
        </div>
      </th>
      <th>
        <div class="vbox">
          Port
          <input [(ngModel)]="filter.port">
        </div>
      </th>
      <th>
        <div class="vbox">
          Username
          <input [(ngModel)]="filter.username">
        </div>
      </th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let element of dataSource.data">
      <td><a routerLink="/ussdCarriers/{{element.id}}">{{element.name}}</a></td>
      <td>{{element.publicAccessKey}}</td>
      <td>{{element.enabled ? 'ENABLED' : 'DISABLED'}}</td>
      <td>{{element.ussdCarrierType}}</td>
      <td>{{element.host}}</td>
      <td>{{element.port}}</td>
      <td>{{element.username}}</td>
    </tr>
    <tr *ngIf="dataSource.data?.length === 0">
      <td colspan="100"><em>No results found</em></td>
    </tr>
    </tbody>
    <tfoot>
    <tr>
      <td colspan="100">
        <mat-paginator #paginator
                       (page)="reload()"
                       [pageSize]="10"
                       [pageSizeOptions]="[5, 10, 20]">
        </mat-paginator>
      </td>
    </tr>
    </tfoot>
  </table>
</div>
